module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAWCAYAAAAW5GZjAAAAPUlEQVQokWN8+PjZfwYiAeN/ICBWMROxCkcV008xC7pAcf10DEW9jZnYTYZJYOX/xwGK6qZhiI0mJPooBgBZ5zwW7mL2kgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zttb1-1.png
// module id = 67
// module chunks = 0